// export const ARTICLE_TYPE_LABELS = {
//     // all: "அனைத்தும்",
//     spiritual_growth: "ஆன்மீக வளர்ச்சி",
//     meditations: "தியானங்கள்",
//     bible_studies: "வேதாகம படிப்புகள்",
//     family: "குடும்பம்",
//     youth: "இளையவர்கள்",
//     life_guidance: "வாழ்க்கை வழிகாட்டி",
//     others: "மற்றவை"
// };

export const ARTICLE_TYPE_LABELS = {
    all: "அனைத்தும்",
    bible_study: "வேதாகம ஆய்வு",
    christian_living: "கிறிஸ்தவ வாழ்க்கை",
    prayer_and_devotion: "ஜெபம் மற்றும் தியானம்",
    faith_and_spiritual_growth: "விசுவாசம் மற்றும் ஆன்மீக வளர்ச்சி",
    biblical_characters: "வேதாகமப் பாத்திரங்கள்",
    inspirational_stories: "ஊக்கமளிக்கும் கதைகள்",
    others: "மற்றவை",
};

// Convert API options → Tamil dropdown
export const mapArticleTypeOptions = (options = []) => {
    const mapped = options
        // ❌ remove "All" option
        .filter((item) => item.label?.toLowerCase() !== "all")
        .map((item) => {
            // const key = item.label
            //     ?.toLowerCase()
            //     .replace(/\s+/g, "_");
            const key = item.label
                ?.toLowerCase()
                .replace(/&/g, "and")
                .replace(/\s+/g, "_");


            return {
                value: item.value,
                label: ARTICLE_TYPE_LABELS[key] || item.label,
            };
        });

    // mapped.push({
    //     value: "others",
    //     label: ARTICLE_TYPE_LABELS["others"],
    // });

    return mapped;
};